import { MouseEvent, ReactNode } from 'react'
import classNames from 'classnames'

import AppHeader, { AppHeaderProps } from '../AppHeader/app-header'
import AppDivider from '../AppDivider/app-divider'
import { type Size } from '../types'

import styles from './app-segment.module.scss'

type AppSegmentProps = {
  children: ReactNode
  maxWidth?: Size
  centered?: boolean
  marginBottom?: Size | boolean
  headerProps?: AppHeaderProps
  disableHeaderOnClickScroll?: boolean
}

const AppSegment = (props: AppSegmentProps) => {
  const {
    children,
    maxWidth,
    centered = false,
    marginBottom = 'large',
    headerProps,
    disableHeaderOnClickScroll = false,
  } = props

  const onClick = (e: MouseEvent<HTMLSpanElement>) => {
    if (disableHeaderOnClickScroll) {
      return
    }
    window.scrollTo({
      top: window.scrollY + e.currentTarget.getBoundingClientRect().top - 10,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className={classNames(
        styles.appSegment,
        maxWidth && styles[maxWidth],
        centered && styles.centered
      )}
    >
      {headerProps?.text && (
        <AppHeader marginBottom="medium" {...headerProps} dividing onClick={onClick} />
      )}
      {children}
      {marginBottom && (
        <AppDivider size={marginBottom === true ? 'large' : marginBottom} />
      )}
    </div>
  )
}

export default AppSegment
